import { render } from "./ProjectsListAdmin.vue?vue&type=template&id=2fd8dfca"
import script from "./ProjectsListAdmin.vue?vue&type=script&lang=js"
export * from "./ProjectsListAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__